import axios from "../axios";

export default {
  //   namespaced: true,
  state: {
    user: null,
    totalQuotes: 0,
    pendingQuotes: 0,
    sendQuotes: 0,
    unreadCounts: 0,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setTotalQuotes(state, totalQuotes) {
      state.totalQuotes = totalQuotes;
    },
    setPendingQuotes(state, pendingQuotes) {
      state.pendingQuotes = pendingQuotes;
    },
    setSendQuotes(state, sendQuotes) {
      state.sendQuotes = sendQuotes;
    },
    setUnreadCounts(state, unreadCounts) {
      state.unreadCounts = unreadCounts;
    },
  },
  actions: {
    async getUser({ commit }) {
      try {
        const token = localStorage.getItem("sanctumToken");
        if (!token) {
          commit("setUser", null);
          commit("setTotalQuotes", 0);
          commit("setPendingQuotes", 0);
          commit("setSendQuotes", 0);
          commit("setUnreadCounts", 0);
          return;
        }
        const response = await axios.get("api/user", {
          withCredentials: true,
        });
        commit("setUser", response.data.user);
        commit("setTotalQuotes", response.data.totalQuotes);
        commit("setPendingQuotes", response.data.pendingQuotes);
        commit("setSendQuotes", response.data.sendQuotes);
        commit("setUnreadCounts", response.data.notificationCount);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          commit("setUser", null);
          commit("setTotalQuotes", 0);
          commit("setPendingQuotes", 0);
          commit("setSendQuotes", 0);
          commit("setUnreadCounts", 0);
        }
      }
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.user,
    getUser: (state) => state.user,
  },
};
